import React from 'react';
import styled, { css } from 'styled-components';

import {
  getContactHeading,
  FEF_HOST,
  KUKARIO_LIMITED_HOST,
  DICOLARE_LIMITED_HOST,
  OZUARA_LIMITED_HOST,
  getContactPageNumber,
  TALENTREE_LIMITED_HOST,
  VERSA_HOST,
} from '/lib/helpers';
import { PhoneIcon } from '/imports/core/ui/assets';
import useIntl from '/imports/core/api/useIntl';
import { useResponsive } from '/imports/core/api/responsiveContext';

const ContactUsInfo = () => {
  const { t } = useIntl();
  const { host } = useResponsive();
  const getCallInfo = () => {
    switch (host) {
      case 'mysmartcv':
        return t('contact.mysmartcv_call_info');
      default:
        return t('contact.call_info');
    }
  };

  const renderHeading = () => {
    switch (true) {
      case host === 'thai-resume':
        return 'France';
      default:
        getContactHeading(host);
    }
  };

  const renderPhoneNumber = () => {
    switch (true) {
      case FEF_HOST.includes(host) ||
        KUKARIO_LIMITED_HOST.includes(host) ||
        DICOLARE_LIMITED_HOST.includes(host) ||
        OZUARA_LIMITED_HOST.includes(host) ||
        VERSA_HOST.includes(host) ||
        TALENTREE_LIMITED_HOST.includes(host):
        return (
          <ContactPhoneWrapper>
            <ContactPhone>
              <PhoneIcon />
              <a href={getContactPageNumber(host).tel}>{getContactPageNumber(host).value}</a>
            </ContactPhone>
          </ContactPhoneWrapper>
        );
      default:
        return (
          <ContactPhoneWrapper>
            <ContactPhone>
              <PhoneIcon />
              <a href="tel:+447360532078">+44 7360 532078</a>
            </ContactPhone>
            <ContactPhone>
              <PhoneIcon />
              <a href="tel:+35315745558">+353 1 574 5558</a>
            </ContactPhone>
          </ContactPhoneWrapper>
        );
    }
  };

  return (
    <ContactsInfo>
      <ContactHeading>{renderHeading()}</ContactHeading>
      <Info>{getCallInfo()}</Info>
      {renderPhoneNumber()}
      <ContactsInfoList>
        <ContactsInfoListItem>
          <ContactsInfoListHeading>{t('contact.monday_friday')}</ContactsInfoListHeading>
          <ContactsInfoListText>9:00am - 7:00pm</ContactsInfoListText>
        </ContactsInfoListItem>
        <ContactsInfoListItem>
          <ContactsInfoListHeading>{t('contact.saturday_sunday')}</ContactsInfoListHeading>
          <ContactsInfoListText>10:00am - 6:00pm</ContactsInfoListText>
        </ContactsInfoListItem>
      </ContactsInfoList>
    </ContactsInfo>
  );
};

const ContactHeading = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #282b32;
  margin-bottom: 14px;
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      direction: rtl;
    `}
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      font-family: ${theme.font.family.websiteSemiBold};
      font-size: 24px;
      line-height: 30px;
      color: var(--dark-values-black);
      margin-bottom: 8px;
    `}
`;

const ContactsInfo = styled.div`
  width: 370px;
  justify-content: flex-start;
  align-items: stretch;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 91px;
  color: #7171a6;
  ${(p) => p.theme.max('md')`
    width: calc(100% - 40px);
    max-width: none;
    margin: 20px;
    margin-left: 20px;
  `}
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      margin-left: 0;
      margin-right: 91px;
    `}
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      ${(p) => p.theme.max('md')`
    width: 100%;
    margin: 48px 0 0 0;
  `}
    `}
`;

const ContactPhone = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 23px;
  border: solid 2px #1688fe;
  width: 186px;
  height: 46px;
  justify-content: center;
  align-items: center;
  margin-bottom: 18px;
  a {
    position: relative;
    font-family: ${({ theme }) => theme.font.family.websiteMedium};
    display: block;
    padding-left: 12px;
    color: #1688fe;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    margin-top: 2px;
    direction: ltr;
    ${({ theme: { isRTL } }) =>
      isRTL &&
      css`
        padding-left: 0;
        padding-right: 12px;
      `}
  }
  svg {
    fill: #1688fe;
  }
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      direction: rtl;
    `}
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      border: none;
      justify-content: flex-start;
      margin-bottom: 16px;
      height: auto;
      a {
        font-weight: 500;
        margin: 0;
        padding-left: 8px;
      }
    `}
`;

const ContactPhoneWrapper = styled.div`
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      width: 100%;
    `}
`;

const ContactsInfoList = styled.div`
  ${(p) => p.theme.max('md')`
    flex-direction: row;
    display: flex;
  `};
  ${(p) => p.theme.max('xs')`
    flex-direction: column;
  `};
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      direction: rtl;
    `}
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      margin-top: 6px;
      flex-direction: column;
      ${(p) => p.theme.max('md')`
          flex-direction: column;
      `};
    `}
`;

const ContactsInfoListItem = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 19px;
  ${(p) => p.theme.max('md')`
    margin-right: 20px;
  `}
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      gap: 8px;
      margin-bottom: 24px;
    `}
`;

const ContactsInfoListHeading = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 14px;
  color: #7171a6;
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      font-size: 15px;
      line-height: 22px;
      color: var(--dark-values-dark-regular);
    `}
`;

const ContactsInfoListText = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 18px;
  line-height: 1.33;
  font-weight: 600;
  color: #282b32;
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      color: var(--dark-values-black);
      font-size: 15px;
      line-height: 22px;
      font-family: ${theme.font.family.websiteSemiBold};
    `}
`;

const Info = styled.div`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 14px;
  line-height: 1.43;
  color: #7171a6;
  margin-bottom: 19px;
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      direction: rtl;
    `}
  ${({ theme }) =>
    theme.isJobTrack &&
    css`
      font-family: ${theme.font.family.websiteSemiBold};
      font-size: 15px;
      line-height: 22px;
      color: var(--dark-values-dark-regular);
      margin-bottom: 24px;
    `}
`;

export default ContactUsInfo;
